// extracted by mini-css-extract-plugin
module.exports = {"table":"BlastCampaignList_table__ioOFA"};